const limaDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Lima',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function limaDateKey(value = new Date()) {
  if (value === null || value === '') return null;
  // Operational DB timestamps are stored as naive America/Lima wall time.
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)
    && !/(Z|[+-]\d{2}:\d{2})$/i.test(value)) {
    return value.slice(0, 10);
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = Object.fromEntries(limaDateFormatter.formatToParts(date).map(part => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function parseLimaOperationalTimestamp(value) {
  if (!value) return null;
  const normalized = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)
    && !/(Z|[+-]\d{2}:\d{2})$/i.test(value)
    ? `${value}-05:00`
    : value;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function isActiveAlertToday(alert, todayKey) {
  return ['open', 'acknowledged'].includes(alert?.status)
    && limaDateKey(alert?.created_at) === todayKey;
}
